import { StaffActivitiesByDescription } from "../types";
import { staffActivities as AAActivities } from "./AA";
import { staffActivities as AKActivities } from "./AK";
import { staffActivities as ALActivities } from "./AL";
import { staffActivities as ARActivities } from "./AR";
import { staffActivities as AZActivities } from "./AZ";
import { staffActivities as CAActivities } from "./CA";
import { staffActivities as COActivities } from "./CO";
import { staffActivities as CTActivities } from "./CT";
import { staffActivities as DCActivities } from "./DC";
import { staffActivities as DEActivities } from "./DE";
import { staffActivities as FLActivities } from "./FL";
import { staffActivities as GAActivities } from "./GA";
import { staffActivities as HIActivities } from "./HI";
import { staffActivities as IAActivities } from "./IA";
import { staffActivities as IDActivities } from "./ID";
import { staffActivities as ILActivities } from "./IL";
import { staffActivities as INActivities } from "./IN";
import { staffActivities as KSActivities } from "./KS";
import { staffActivities as KYActivities } from "./KY";
import { staffActivities as LAActivities } from "./LA";
import { staffActivities as MAActivities } from "./MA";
import { staffActivities as MDActivities } from "./MD";
import { staffActivities as MEActivities } from "./ME";
import { staffActivities as MIActivities } from "./MI";
import { staffActivities as MNActivities } from "./MN";
import { staffActivities as MOActivities } from "./MO";
import { staffActivities as MSActivities } from "./MS";
import { staffActivities as MTActivities } from "./MT";
import { staffActivities as NCActivities } from "./NC";
import { staffActivities as NDActivities } from "./ND";
import { staffActivities as NEActivities } from "./NE";
import { staffActivities as NHActivities } from "./NH";
import { staffActivities as NJActivities } from "./NJ";
import { staffActivities as NMActivities } from "./NM";
import { staffActivities as NVActivities } from "./NV";
import { staffActivities as NYActivities } from "./NY";
import { staffActivities as OHActivities } from "./OH";
import { staffActivities as OKActivities } from "./OK";
import { staffActivities as ORActivities } from "./OR";
import { staffActivities as PAActivities } from "./PA";
import { staffActivities as PRActivities } from "./PR";
import { staffActivities as RIActivities } from "./RI";
import { staffActivities as SCActivities } from "./SC";
import { staffActivities as SDActivities } from "./SD";
import { staffActivities as TNActivities } from "./TN";
import { staffActivities as TXActivities } from "./TX";
import { staffActivities as UTActivities } from "./UT";
import { staffActivities as VAActivities } from "./VA";
import { staffActivities as VTActivities } from "./VT";
import { staffActivities as WAActivities } from "./WA";
import { staffActivities as WIActivities } from "./WI";
import { staffActivities as WVActivities } from "./WV";
import { staffActivities as WYActivities } from "./WY";

export const allStaffActivitiesByDescription: StaffActivitiesByDescription = {
  ...AAActivities,
  ...AKActivities,
  ...ALActivities,
  ...ARActivities,
  ...AZActivities,
  ...CAActivities,
  ...COActivities,
  ...CTActivities,
  ...DCActivities,
  ...DEActivities,
  ...FLActivities,
  ...GAActivities,
  ...HIActivities,
  ...IAActivities,
  ...IDActivities,
  ...ILActivities,
  ...INActivities,
  ...KSActivities,
  ...KYActivities,
  ...LAActivities,
  ...MAActivities,
  ...MDActivities,
  ...MEActivities,
  ...MIActivities,
  ...MNActivities,
  ...MOActivities,
  ...MSActivities,
  ...MTActivities,
  ...NCActivities,
  ...NDActivities,
  ...NEActivities,
  ...NHActivities,
  ...NJActivities,
  ...NMActivities,
  ...NVActivities,
  ...NYActivities,
  ...OHActivities,
  ...OKActivities,
  ...ORActivities,
  ...PAActivities,
  ...PRActivities,
  ...RIActivities,
  ...SCActivities,
  ...SDActivities,
  ...TNActivities,
  ...TXActivities,
  ...UTActivities,
  ...VAActivities,
  ...VTActivities,
  ...WAActivities,
  ...WIActivities,
  ...WVActivities,
  ...WYActivities,
};

/**
 * To log, use encamp tinker:
 * ```
 * > encamp tinker
 * encamp> logStaffDepdencies();
 * ```
 */
export function logStaffDepdencies() {
  Object.entries(allStaffActivitiesByDescription).forEach(([key, activity]) => {
    const dependsOn =
      activity.jurisdictionType !== "City/County"
        ? activity.jurisdictionType ?? "Disabled"
        : activity.dependsOn?.join(", ") ?? "";
    console.log(`${activity.state},"${key}","${dependsOn}"`);
  });
}
